// UtilColorPalette.js

// Default color values
export let GlobalHeaderColor = '#e9e9e9';
export let QuickCreatePanelColor = '#8C7AA2';
export let ButtonsColor = '#8c7aa266';
export let IconsColor = '#8C7AA2';
export let TableHeaderColor = '#e9e9e9';
export let OnHoverColor = 'rgba(140, 122, 162,0.1)';  
export let LeftPanelColor = '#fff';
export let PageBackgroundColor = '#fff';
export let TextColor = '#222';
export let PipelineStageColor = '#8C7AA2';
export let DisabledColor ="#D3D3D3";
export let CardColor ="#fff";

// //////////Extra Colors/////

export let deleteIconColor = "#FF474C";
export let NavBarColor = "rgba(140, 122, 162,0.4)"; //navBarbgColor
export let primaryColor = '#8C7AA2';
export let appColor = "#fff";
export let subColor = '#e9e9e9';
export let tableHoverColor ="rgba(140, 122, 162,0.1)"
export let fontFamilyall ='Nunito Sans';
export let todayColor ="red";
export let tomorrowColor ="green"
export let cardTitleColor ="#0D47A1";
export let CustomTabBorder = "1px solid #ddd";

